'use strict';

import app from './app';
import routerConfig from './router';
import run from './run';

app.config(routerConfig);
app.run(run);

angular.bootstrap(document, ['app']);



// WEBPACK FOOTER //
// ./resources/assets/app-releases/index.js